import Super from 'client-portal/routes/-request/channel-uploads';
import classic from 'ember-classic-decorator';

@classic
export default class SiteRequestChannelUploads extends Super {}
